module.exports = __webpack_public_path__ + "media/analytics/bghead-e0e4f195.png";